import { render, staticRenderFns } from "./CredenciamentoEsclarecimentoImpugnacaoVazio.vue?vue&type=template&id=35ada2b4&scoped=true"
import script from "./CredenciamentoEsclarecimentoImpugnacaoVazio.vue?vue&type=script&lang=js"
export * from "./CredenciamentoEsclarecimentoImpugnacaoVazio.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoEsclarecimentoImpugnacaoVazio.vue?vue&type=style&index=0&id=35ada2b4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ada2b4",
  null
  
)

export default component.exports